// https://vuex.vuejs.org/en/getters.html

export default {
  checkIfIsInProductList: state => {
    if (state.googleShoppingInfo.selectedProduct) {
      return state.googleShoppingInfo.productList
        .map(p => parseInt(p.id))
        .includes(parseInt(state.googleShoppingInfo.selectedProduct.id));
    } else {
      return false;
    }
  },
  checkIfIsInSearchResults: state => search => {
    if (search && state.googleShoppingInfo.searchedProducts) {
      return state.googleShoppingInfo.searchedProducts.map(p => p.text).includes(search);
    } else {
      return false;
    }
  },
};
